const config = {
  // LOCAL (untuk testing lokal saja)
  // apiUrl: "http://localhost/HRIS%20BCK/digajiin_be/public/",
  // storageUrl: "http://localhost/HRIS%20BCK/digajiin_be/storage/",

  apiUrl: "https://digajiinbe.bck.co.id/public/",
  storageUrl: "https://digajiinbe.bck.co.id/storage/",
};

export default config;
